module.exports = __webpack_public_path__ + "static/media/product-service-modal.bbc9ce10.svg";